import React from "react";
import { Link } from "react-router-dom";
import NotificationsActive from "@mui/icons-material/NotificationsActive";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Skeleton from "@mui/material/Skeleton";
import { Path } from "../Path";
import { formatFullDate } from "../core/date-formatting";
import { getNextOccurrenceDate } from "./model";
import { GameName } from "../games/ListItem";
import { PublisherLogoFromId } from "../publisher/PublisherLogo";
import ListItemIcon from "@mui/material/ListItemIcon";

/**
 * @param {import("@seabrookstudios/types").GameId[]} gameIds
 */
const getReminderSecondary = (gameIds = []) => {
  return gameIds.map((gameId, index) => (
    <React.Fragment key={gameId}>
      <GameName gameId={gameId} />
      {index < gameIds.length - 1 && ", "}
    </React.Fragment>
  ));
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").RoyaltyReminder} props.item
 */
export const RoyaltyReminderListEntry = ({ item }) => {
  if (!item) {
    return <Skeleton />;
  }

  const nextOccurrenceDate = getNextOccurrenceDate(item.startDate, item.cycleType);
  if (!nextOccurrenceDate) {
    return <Skeleton />;
  }

  return (
    <ListItemButton alignItems="flex-start" component={Link} to={Path.royalties().reminder(item.id)}>
      <ListItemAvatar>
        <NotificationsActive />
      </ListItemAvatar>
      <ListItemText primary={formatFullDate(nextOccurrenceDate)} secondary={getReminderSecondary(item.gameIds)} />
      <ListItemIcon>
        <PublisherLogoFromId publisherId={item.publisherIds[0]} />
      </ListItemIcon>
    </ListItemButton>
  );
};
